import { useCallback } from 'react';

import { useAppsFlyer } from '@ocx/cap-appsflyer';
import { useIsOnline } from '@ocx/utils-device';
import { useGetNavigationActions } from '@ocx-app/hooks/useGetNavigationActions';
import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';

import { useAlerts } from '../alerts/use-alerts.hook';

export interface IUseStartPayInsideParams {
  isEmailCompleted: boolean;
}

export const useStartPayInside = (params: IUseStartPayInsideParams) => {
  const { triggerEvent } = useRudderStack();
  const { logEvent: logAppsFlyerEvent } = useAppsFlyer();

  const alerts = useAlerts();
  const isOnline = useIsOnline();
  const { pushToPayInside } = useGetNavigationActions();
  const { isEmailCompleted } = params;

  return useCallback(async () => {
    triggerEvent('scan_for_pay_inside_clicked');

    if (!isOnline) {
      alerts.showNoConnectionAlert();
      return;
    }

    if (!isEmailCompleted) {
      alerts.showCompleteEmailAlert({
        onCompleted: () => {
          // It was decided to hardcode the event name for Gulf until AppsFlyer
          // will be used by other clients. It should be changed to more generic name later.
          logAppsFlyerEvent({
            eventName: 'gp_email_address_entered',
          });
          pushToPayInside();
        },
      });
      return;
    }

    pushToPayInside();
  }, [isEmailCompleted, isOnline, pushToPayInside, alerts, triggerEvent, logAppsFlyerEvent]);
};
